import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';
import { orderDetailsForm } from '../../utils/constant';

const ProceedWithOrder = ({ orderData }) => {
  const { locale, categoryName, id, step, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, proceedWithOrder },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;
  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleProceedWithOrder = () => {
    const newStep = step === 1 ? 2 : step;
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=${newStep}`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{proceedWithOrder}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText="Are you sure you want to proceed with modifying the order?"
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleProceedWithOrder()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

ProceedWithOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ProceedWithOrder;
